import I18n from 'i18n-js';

type Category = [
    string,     // Kategorien-ID
    string,     // Kategorien-Titel
    string[],   // IDs der Produkte
];

interface Categories {
    [key: string]: Category;
}

export const CATEGORIES: Categories = (window as any).CATEGORIES;

export function thumbnailKeyFor(item: YooconShop.Item) {
    // wenn ein Produkt Material-Varianten hat, wie der Stool, werden die entsprechenden Bilder geladen
    // wenn ein Produkt nur verschiedene Dimensionen (Zahlenangaben) hat wird das Standard-Produktbild geladen
    let result = '';
    if(item.payload && typeof item.payload == 'string') {
        const parts = item.payload.split("-");
        for(let p = 0; p < parts.length; p++) {
            if(/^[0-9x]+\*?$/.test(parts[p])) continue;
            result += '-'+parts[p];
        }
    }
    return result;
}

export function thumbnailUrlWithKeyFor(item: YooconShop.Item, key: string) {
    if(item.item_no)
        return '/assets/img/desktop/products/checkout/thumbs/'+ item.item_no + key + '-intro.webp';
}

export function thumbnailUrlFor(item: YooconShop.Item) {
    const key = thumbnailKeyFor(item);
    return thumbnailUrlWithKeyFor(item, key);
}

export function addLocaleToUrl(url: string | undefined) {
    if(url === undefined) return '';
    return url.replace(/([^\/:])\//, '$1/'+I18n.locale+'/');
}

export function checkoutUrl() {
    return `/${I18n.locale}/checkout.php`;
}

export function privacyUrl(anchor?: string) {
    let result = `/${I18n.locale}/privacy.php`;
    if(anchor) result += `#${anchor}`;
    return result;
}

export function submitNewsletterUrl() {
    return 'https://lists.yoocon.de/lists/newsletter@nutsandwoods.de/subscriptions';
}
